<template>
  <container>
    <modal-one-signal :race-id="raceIdToNotification" @close-modal="closeOneSignal" v-if="raceIdToNotification" />
    <race-header title="Races" class="new-races-top">
      <router-link to="/admin/races/add" class="btn btn--primary new-race-btn" id="newrace" slot="actions">+ New Race</router-link>
    </race-header>
    <table class="table table--full">
      <thead>
        <tr>
          <th>Name</th>
          <th>Description</th>
          <th>Duration</th>
          <th>Status</th>
          <th>Type</th>
          <th>Date</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="race in races" :key="race.id">
          <td width="200px">{{race.name}}</td>
          <td width="250px">{{race.description}}</td>
          <td width="130px">{{race.duration}} minutes</td>
          <td width="100px">{{getStatusRace(race)}}</td>
          <td width="260px">{{race.type}}</td>
          <td width="270px">{{race.date | date}}</td>

          <td class="race-operation" width="250px">
            <div id="wrapper"  v-show="activeRaceId!=race.id ||activeRaceId==0">
              <router-link  :to="{ path:`/admin/races/edit/${race.id}` }"
                class="btn btn--primary btn--block cbutton" v-if="race.startDate === null">Edit</router-link>
              <button style="margin-left:5px" v-show="activeRaceId!=race.id " id="delete2"
                class="btn btn--danger btn--block cbutton" v-on:click="handleDelete(race)">Delete
              </button>
            </div>

             <div class="confirmation"  v-show="deleteMode">
              <span v-if="activeRaceId==race.id">
                <label>Sure?</label>
                <button class="btn btn--primary " v-on:click="deleteRaceSelected(race,event)">Yes</button>
                <button v-on:click="Clear" class="btn btn-xs btn-danger">No</button>
              </span>
            </div>
          </td>
        </tr>
      </tbody>

    </table>

    <!-- Debug Options Block -->
    <debug-race-creator v-if="showDebugOptions"></debug-race-creator>

  </container>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex'
  import {
    db
  } from '../../firebase'
  import Container from '@/components/Container'
  import RaceHeader from '@/components/Race/Header'
  import ModalOneSignal from '@/components/ModalOneSignal'
  import RaceQuestion from '@/components/LiveRun/Race/Question'
  import RaceQuestionService from '../../services/raceQuestion'
  import DebugRaceCreator from '@/components/Races/DebugRaceCreator'
  export default {
    name: 'list-race',
    data: () => ({
      // activeClass: 'active',
      deleteMode: false,
      activeRaceId: 0,
      delete: true,
      raceIdToNotification: null,
      showQuestionModal: false,
      raceId: null,
      todayQuestion: {}
    }),
    props: {
      isSaved: Boolean
    },
    computed: {
      ...mapGetters({
        trainer: 'Trainer/trainer',
        races: 'RacesByTrainer/scheduleraces',
        question: 'RaceQuestion/question',
      }),
      showDebugOptions() {
        return this.$isDevMode()
      }
    },
    methods: {
      closeOneSignal() {
        this.raceIdToNotification = null
      },
      initialize() {
        try {
          // Add tasks to queue without chaining
          this.addTaskToQueue('getTrainer')
          this.addTaskToQueue('getRacesByTrainer')

          // Handle trainer fetch separately
          this.getTrainer(this.$auth.user().id)
            .then(() => {
              this.removeTaskFromQueue('getTrainer')
            })
            .catch(error => {
              console.error('Error getting trainer:', error)
              this.removeTaskFromQueue('getTrainer')
            })
        } catch (error) {
          console.error('Error in initialize:', error)
        }
      },
      getRaces() {
        if (!this.trainer || !this.trainer.id) {
          console.error('No trainer ID available for getRaces')
          this.removeTaskFromQueue('getRacesByTrainer')
          return Promise.resolve()
        }

        return this.getRacesByTrainer(this.trainer.id)
          .then(() => {
            this.removeTaskFromQueue('getRacesByTrainer')
          })
          .catch(error => {
            console.error('Error getting races:', error)
            this.removeTaskFromQueue('getRacesByTrainer')
          })
      },

      Clear(race) {
        this.activeRaceId = race.id
        this.deleteMode = false

      },
      handleDelete(race) {
        this.activeRaceId = race.id
        this.deleteMode = true

        //this.delete2[race.id] = true
        //delete2[race.id].removeAttribute('disabled', true)
        //var retVal = confirm("Are you sure you want to delete ?")
        // if( retVal == true ){
        //     alert("User wants to delete!")
        //     this.deleteRace(race)
        //     .then(this.getRaces)
        //     .then(() => this.loadingDelete(event.target, false))
        //     .catch(() => this.loadingDelete(event.target, false))
        // }
        // else{
        //     alert ("User does not want to delete!")
        // }
      },
      deleteRaceSelected(race, event) {
        this.deleteRace(race)
          .then(() => this.getRaces())
          .then(() => this.loadingDelete(event.target, false))
          .catch(() => this.loadingDelete(event.target, false))
        this.deleteMode = false
      },
      ...mapActions({
        getTrainer: 'Trainer/get',
        deleteRace: 'Race/deleteOne',
        getRacesByTrainer: 'RacesByTrainer/get',
        addTaskToQueue: 'LoadingQueue/addTaskToQueue',
        removeTaskFromQueue: 'LoadingQueue/removeTaskFromQueue'
      }),
      loadingDelete(target, active = true) {
        const btn = target

        btn.disabled = active
        btn.innerHTML = active ? 'Deleting...' : 'Delete'
      },
      getStatusRace(race) {
        if (race.startDate === null && race.finishDate === null) {
          return 'to start'
        } else if (race.startDate !== null && race.finishDate === null) {
          return 'in progress'
        } else if (race.startDate !== null && race.finishDate !== null) {
          return 'finished'
        }
      },
      openNotification(raceId) {
        this.raceIdToNotification = raceId
      }
    },
    created() {
      this.initialize()

    },
    watch: {
      trainer() {
        this.getRaces()
      }
    },
    components: {
      Container,
      RaceHeader,
      ModalOneSignal,
      RaceQuestion,
      DebugRaceCreator
    }
  }

</script>
<style>
  .race-operation #wrapper {
    width: 100%!important;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0px!important;
    padding-bottom: 0px!important;
  }

  .new-race-btn {
    float: right;
    margin-left: auto;
  }

  /* .cbutton {
    height: 20px;
    padding: 5px 0px 18px 0px;
    line-height: 15px;
  } */

</style>



// WEBPACK FOOTER //
// List.vue?0e689efd